import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Transfer } from 'components/Page';
import config from './config';

const UserPermissions = ({ objectId, permissions }) => {
  // if record is localy managed and the user has permissions
  const canAdmin = permissions.CanAdminUsers()
    .hasPermissions();
  return (
    <Transfer
      canAdmin={canAdmin}
      reducer={{
        destination: REDUCER_KEY.assignedUserGroups,
        source: REDUCER_KEY.unAssignedUserGroups
      }}
      objectId={objectId} // the parent object
      config={{
        ...config,
        // Table ToolBar Buttons
        commands: {
          disableAdd: !canAdmin,
          disableRemove: !canAdmin
        },
        // override source table config with current data
        source: {
          ...config.source,
          // Table row config
          rowSelectionConfig: {
            ...config.source.rowSelectionConfig,
            highlightRow: canAdmin
          },
          filters: {
            user_id__ne: [objectId]
          }
        },
        // override destination table config with current data
        destination: {
          ...config.destination,
          // record filter for assigned users
          filters: {
            user: [objectId]
          }
        }
      }}
      permissions={permissions}
    />
  );
};

UserPermissions.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

UserPermissions.defaultProps = {
  objectId: null
};

export default UserPermissions;
